import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  StreamHeader,
  StreamHeaderProps,
} from '../../../features/StreamHeader/StreamHeader';
import {StreamHeaderErrorView} from '../../../features/StreamHeader/StreamHeaderErrorView';
import {StreamHeaderLoading} from '../../../features/StreamHeader/StreamHeaderLoading';
import {useCategoryStreamFiltersData} from '../Filters/shared/useCategoryStreamFiltersData';
import {StreamGenderSwitch} from '../StreamGenderSwitch/StreamGenderSwitch';

export const CategoryStreamHeader: React.FC<StreamHeaderProps> = props => (
  <DataFetcher
    request={useCategoryStreamFiltersData()}
    Error={StreamHeaderErrorView}
    Loading={StreamHeaderLoading}
    View={viewProps => (
      <StreamHeader
        {...viewProps}
        StreamGenderSwitch={<StreamGenderSwitch />}
      />
    )}
    viewProps={props}
  />
);
